import {
  DEFAULT_VALUES,
  KODEM_HELM_REPO_URL
} from "@/pages/DeploymentsPage/const"
import { getDeployCommandString } from "@/pages/DeploymentsPage/helpers/deployment-command"

export const getDefaultValues = (initialValues?: Record<string, string>) => {
  const { kodemHelmRepo = DEFAULT_VALUES.KODEM_HELM_REPO } = initialValues || {}

  return {
    key: Date.now().toString(),
    kodemHelmRepo: kodemHelmRepo
  }
}

export const getLines = (names = ["kodemHelmRepo"]) => ({
  1: {
    text: "helm repo add",
    name: names[0],
    align: "space-between" as const,
    suffix: ` ${KODEM_HELM_REPO_URL} &&`
  },
  2: {
    text: "helm repo update"
  }
})

export const getDeployCommand = (
  values: ReturnType<typeof getDefaultValues>,
  defaultValues: ReturnType<typeof getDefaultValues>
) => {
  const lines = getLines()

  return getDeployCommandString({
    lines,
    values,
    defaultValues
  })
}
